import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="7" height="9" viewBox="0 0 7 9" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path opacity=".4" d="M3.36.28C1.43.28.46 1.5.43 3.02h1.72c.02-.88.48-1.26 1.26-1.26.77 0 1.15.47 1.15 1.02 0 .68-.43.9-1.02 1.34-.82.6-1.18 1.03-1.18 1.99v.31h1.72v-.31c0-.52.2-.72.77-1.1.79-.56 1.45-1.06 1.45-2.24 0-1.39-.95-2.5-2.94-2.5zM4.13 9V7.18H2.29V9h1.84z" /></svg>);